import { render, staticRenderFns } from "./NovaContaPagamento.vue?vue&type=template&id=6bbcb30e&"
import script from "./NovaContaPagamento.vue?vue&type=script&lang=js&"
export * from "./NovaContaPagamento.vue?vue&type=script&lang=js&"
import style0 from "./NovaContaPagamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports